import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { formatLocalizedNumber } from '@app/types/translatable.type';
import { WorkersCompensation } from '@app/models/payroll/workers-compensation.model';

export class RateColumn extends Column {
    title = 'table.workers-compensations.rate';
    property = 'rate';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(row: WorkersCompensation): string {
        if (row.rate === null || row.rate === undefined) {
            return '-';
        }
        return formatLocalizedNumber(row.rate, { locale: row.locale, decimalPlaces: 1 }) || '-';
    }
}
